import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import { Button, IconButton, Typography, useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';

function DateTimeList(props) {
    const { handleOpenDateTimeDialog, dateTimeConditions, handleRemoveDateTime, disabled, inherit } = props;

    const theme = useTheme();

    const getDayLabel = (days) => {
        const dayMap = {
            monday: 'Mon.',
            tuesday: 'Tue.',
            wednesday: 'Wed.',
            thursday: 'Thu.',
            friday: 'Fri.',
            saturday: 'Sat.',
            sunday: 'Sun.',
        };

        const weekOrder = [
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday',
        ];

        const workDay = weekOrder.slice(0, 5);
        const weekEnd = weekOrder.slice(5);
        const everyDay = weekOrder;

        // เรียงลำดับตามวันในสัปดาห์
        const sortedDays = weekOrder.filter(day => days.includes(day));

        if (JSON.stringify(sortedDays) === JSON.stringify(workDay)) return 'Mon. - Fri.';
        if (JSON.stringify(sortedDays) === JSON.stringify(weekEnd)) return 'Sat. - Sun.';
        if (JSON.stringify(sortedDays) === JSON.stringify(everyDay)) return 'Every day';

        const labels = sortedDays.map(day => dayMap[day]);
        return labels.join(', ');
    };

    return (
        <div className='mt-4'>
            {dateTimeConditions.map((cond, index) => {
                return (
                    <div
                        key={index}
                        className='border border-gray-300 rounded-sm mb-4 px-1 py-2 cursor-pointer'
                        onClick={() => {
                            if (!inherit) {
                                handleOpenDateTimeDialog(index)
                            }
                        }}
                    >
                        <div className='w-full grid grid-cols-[49%_1%_40%_10%] justify-center items-center'>
                            <Typography
                                variant="caption"
                                noWrap
                                sx={{
                                    textAlign: 'center',
                                    alignItems: 'center',
                                    maxWidth: 130,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    px: 1
                                }}
                            >
                                {getDayLabel(cond.days)}
                            </Typography>
                            <div className="h-6 w-px bg-gray-300"></div>
                            <Typography
                                variant="caption"
                                // color='primary'
                                sx={{
                                    textAlign: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                {`${cond.start} - ${cond.end}`}
                            </Typography>
                            {inherit ?
                                <></> :
                                <IconButton
                                    variant="outlined"
                                    size="small"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleRemoveDateTime(dateTimeConditions, index)
                                    }}
                                >
                                    <DeleteIcon fontSize="small" color="action" />
                                </IconButton>
                            }
                        </div>
                    </div>
                )
            })}
            {!inherit &&
                <Button
                    sx={{
                        border: '1px solid #ccc',
                        '&.Mui-disabled': {
                            bgcolor: theme.palette.action.disabledBackground,
                            color: theme.palette.action.disabled,
                        },
                    }}
                    variant="outlined"
                    fullWidth
                    disabled={disabled}
                    onClick={() => handleOpenDateTimeDialog(null)}
                >
                    <AddIcon color='action' />
                </Button>
            }
        </div>
    )
}

export default DateTimeList